import { render, staticRenderFns } from "./BaseForgotPassword.vue?vue&type=template&id=4b04dd7b"
import script from "./BaseForgotPassword.vue?vue&type=script&lang=js"
export * from "./BaseForgotPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports